import * as Sentry from "@sentry/react";
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import AppRoutes from './AppRoutes'

// Initialize Sentry
Sentry.init({
  dsn: "https://ef803a9a961a5e6777c241ff6ae4a23b@o4505928565719040.ingest.us.sentry.io/4509795840032768",
  sendDefaultPii: false
});

// Render the app
const container = document.getElementById('root')!
if (!container.innerHTML) {
  const root = createRoot(container)
  root.render(
    <StrictMode>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </StrictMode>,
  )
}